export type ChannelTab = "wecom" | "web";

/**
 * 默认页签(1010 一期补完 B7):URL 显式 `?tab=web|wecom` 优先;否则企微客服确认没绑 → 网页 / H5
 * (H5-only 租户进来第一眼就是能用的那个渠道);已绑 / 查不到 → 企微(老租户行为不变)。
 */
export function pickChannelTab(param: string | null, wecomBound: boolean | undefined): ChannelTab {
  if (param === "web" || param === "wecom") return param;
  return wecomBound === false ? "web" : "wecom";
}
